import type { Issue } from '../../services/board-store/types';

export const batchIssuesForSubtasks = (issues: Issue[], issueIds: number[]) => {
	const batches: number[][] = [];

	let batch: number[] = [];
	let subtaskCount = 0;

	issueIds.forEach((issueId) => {
		const issue = issues.find((i) => i.id === issueId);
		if (issue?.subtaskMetadata) {
			const totalSubtasks = issue.subtaskMetadata.total;
			if (subtaskCount + totalSubtasks > 100) {
				batches.push(batch);
				batch = [issueId];
				subtaskCount = totalSubtasks;
			} else {
				batch.push(issueId);
				subtaskCount += totalSubtasks;
			}
		}
	});

	batches.push(batch);
	return batches;
};
